import API from "../configs/axiosInstance";

const getServiceList = () => {
    return API({
        url: `/account-service/v1/port-services/all`,
        method: 'GET',
    });
};

const getVulnerability = () => {
    return API({
        url: `/account-service/v1/vulnerabilities/all`,
        method: 'GET',
    });
};

const addVulnerability = (data = {}) => {
    return API({
        url: `/account-service/v1/vulnerabilities`,
        method: 'POST',
        data
    });
};

const saveVulnerability = (data = {}) => {
    return API({
        url: `/account-service/v1/port-services/${data.id}/vulnerabilities`,
        method: 'POST',
        data: data.selectedValues
    });
};

const vulnerableById = (id) => {
    return API({
        url: `/account-service/v1/port-services/vulnerable-by-id/${id}`,
        method: 'POST',
    });
};

const vulnerableByPort = (id) => {
    return API({
        url: `/account-service/v1/port-services/vulnerable-by-port-service/${id}`,
        method: 'POST',
    });
};

const getVulnerabilityDetected = () => {
    return API({
        url: `account-service/v1/port-services/vulnerable?size=500`,
        method: 'POST',
    });
};
const getSearchVulnerability = (search) => {
    return API({
        url: `account-service/v1/mend-vulnerabilities/${search}`,
        method: 'GET',
    });
};
const getAllVulnerabilities = (data = {}) => {
    return API({
        url: `account-service/v1/asset-vulnerabilities/all`,
        method: 'POST',
        data,
    });
};
const exportExcelVulnerabilities = (data = {}) => {
    return API({
        url: `account-service/v1/asset-vulnerabilities/excel-export`,
        method: 'POST',
        data,
        responseType: 'blob'
    });
};

const getIssueStatus = () => {
    return API({
        url: `/account-service/v1/vulnerabilities/status`,
        method: 'GET',
    });
};

const getAllVulnerabilityTypeCounts = () => {
    return API({
        url: `/issue-service/incidents/count-all-level`,
        method: 'GET',
    });
};

const getAssetWithMostCriticalIssues = () => {
    return API({
        url: `/issue-service/incidents/task-critical-level`,
        method: 'GET',
    });
};

const exportTabExcel = (data) => {
    return API({
        url: `/account-service/v1/domains/export-tab`,
        method: 'POST',
        data: data,
        responseType: 'blob'
    });
};

const vulnerabilityService = {
    getServiceList,
    getVulnerability,
    addVulnerability,
    vulnerableById,
    vulnerableByPort,
    saveVulnerability,
    getVulnerabilityDetected,
    getSearchVulnerability,
    getAllVulnerabilities,
    exportExcelVulnerabilities,
    getIssueStatus,
    getAllVulnerabilityTypeCounts,
    getAssetWithMostCriticalIssues,
    exportTabExcel
};

export default vulnerabilityService;
